<template>
    <section class="section df">
        <div class="l-box">
            <div class="nav-title">
                我的收藏
            </div>

            <router-link :to="`/spaces/${id}/collect`" exact class="nav-item">
                <div class="nav-name"><i class="icon-folder"></i>视频收藏夹</div>
                {{video}}
            </router-link>

            <router-link :to="`/spaces/${id}/collect/activities`" class="nav-item">
                <div class="nav-name"><i class="icon-folder"></i>动态收藏夹</div>
                {{activity}}
            </router-link>

            <router-link :to="`/spaces/${id}/collect/info`" class="nav-item">
                <div class="nav-name"><i class="icon-folder"></i>资讯收藏夹</div>
                {{info}}
            </router-link>

        </div>
        <div class="r-box">
            <router-view :video="video" :activity="activity" :info="info" @videoDecr="() => video--" @activityDecr="() => activity--"></router-view>
        </div>
    </section>
</template>

<script>
    export default {
        data: () => ({
            video: 0,
            activity: 0,
            info: 0,
        }),
        computed: {
            id() {
                return this.$route.params.id;
            },
        },
        methods: {

        },
        beforeMount() {
            this.api.get(`users/${this.id}/collect/count`).then(e => {
                this.is_loading = false;
                this.video = e.video;
                this.activity = e.activity;
                this.info = e.info;
            }, e => {
                this.is_loading = false;
                this.alert.err(e.message);
            });

        }
    }
</script>

<style scoped>
    @import "../../../../static/css/views/space/collect/nav.css";
</style>


// WEBPACK FOOTER //
// src/views/space/collect/Nav.vue